import React, {useState, useEffect } from 'react';
import api from './services/api';

import LinkHover from './LinkHover'

function Header (props){

  const [currentUser, setCurrentUser] = useState("")
  const [currentId, setCurrentId] = useState("")

  // useEffect(()=>{
  //   api.get("/login").then((response) => {
  //     if(response.data.loggedIn === true){
  //       setCurrentUser(response.data.user[0].user_name)
  //       setCurrentId(response.data.user[0].user_id)
  //     } else {
  //       console.log(response)
  //     }
  //   })
  // }, [])

  return(
    <div style = {{display: 'flex', listStyle: 'none', justifyContent: 'space-between', width: '86vw'}}>
      <h2 style={{
          margin: '40px 0 20px 0',
        }}>
        <LinkHover
          linkName="Research Synthase"
          pageRef="/"
          letterSize='30px'
          />
      </h2>
      <nav  style = {{
          display: 'flex',
          justifyContent: 'space-between',
          listStyle: 'none',
          margin: '50px 0 20px 0',
        }}>
        <li>
          <LinkHover
            linkName="People"
            pageRef="/prephysician_gallery"
            letterSize='18px'
            />
        </li>
        <li>
          <LinkHover
            linkName="Projects"
            pageRef="/project_gallery"
            letterSize='18px'
            />
        </li>
        {!currentUser
            ?
              <div style = {{display: 'flex'}}>
                <li>
                  <LinkHover
                    linkName="Login"
                    pageRef="/login"
                    letterSize='18px'
                    />
                </li>
                <li>
                  <LinkHover
                    linkName="Sign-up"
                    pageRef="/signup"
                    letterSize='18px'
                    />
                </li>
              </div>
            :
              <div
                style = {{display: 'flex'}}>
                <li>
                  <LinkHover
                    linkName={`${currentUser}'s stuff`}
                    pageRef={`/home/${currentId}`}
                    letterSize='18px'
                    />
                </li>
                <li>
                  <LinkHover
                    linkName="Logout"
                    pageRef="/logout"
                    letterSize='18px'
                    />
                </li>
              </div>
          }
      </nav>
    </div>

  )
}

export default Header





// <html>
// <head>
// 	<title>Project details</title>
// 	<link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.6.3/css/all.css" integrity="sha384-UHRtZLI+pbxtHCWp1t77Bi1L4ZtiqrqD80Kn4Z8NTSRyMA2Fd33n5dQ8lWUE00s/" crossorigin="anonymous">
// 	<link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.2.1/css/bootstrap.min.css" integrity="sha384-GJzZqFGwb1QTTN6wy59ffF1BuGJpLSa9DkKMp0DgiMDm4iYMj70gZWKYbI706tWS" crossorigin="anonymous">
// 	<link rel="stylesheet" type="text/css" href="/stylesheets/index.css">
// 	<link href="https://fonts.googleapis.com/css?family=Economica:400,700|Open+Sans:400,700|Roboto:400,700" rel="stylesheet">
//
// </head>
// <body>
